// SUMMARY: Pure text folding shared by the index, the query side and the client. Kept separate from
// tokenize.ts on purpose: that module imports node:crypto for the keyed hashing, and the navbar's
// client-side navigation matcher must not drag a Node built-in into the browser bundle.

// German folding runs before accent stripping so ö becomes "oe" rather than "o" - matching how people
// actually type these words when they skip the umlaut.
const GERMAN_FOLD: Array<[RegExp, string]> = [
	[/ä/g, 'ae'],
	[/ö/g, 'oe'],
	[/ü/g, 'ue'],
	[/ß/g, 'ss'],
]

/**
 * Fold text to its index form: lowercase, umlauts expanded, remaining accents stripped.
 *
 * @example normalizeTerm("Verträge") → "vertraege"
 * @example normalizeTerm("CAFÉ")     → "cafe"
 */
export function normalizeTerm(term: string): string {
	let value = term.toLowerCase()
	for (const [pattern, replacement] of GERMAN_FOLD) value = value.replace(pattern, replacement)
	// NFD splits "é" into "e" + combining accent; the range then removes the accent itself.
	return value.normalize('NFD').replace(/[̀-ͯ]/g, '')
}
